import React, { useState, useCallback } from 'react';
import { useAccount } from '../contexts/AccountContext';
import OAuthManagement from './admin/OAuthManagement';
import './AdminPage.css';

function OAuthPage({ user }) {
  const { getAccountIdToUse } = useAccount();
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  // Get current account
  const accountId = getAccountIdToUse();

  // Get user ID
  const getUserId = () => user?.userId || user?.id;

  // Refresh handler
  const handleRefresh = useCallback(() => {
    setRefreshTrigger(prev => prev + 1);
  }, []);

  // If no account is selected, show a message
  if (!accountId) {
    return (
      <div className="admin-container">
        <div className="admin-content">
          <div className="loading-container">
            <div className="loading-content">
              <p>Please select an account from the sidebar to manage OAuth connections.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-container">
      <OAuthManagement
        userId={getUserId()}
        accountId={accountId}
        user={user}
        refreshTrigger={refreshTrigger}
        onRefresh={handleRefresh}
      />
    </div>
  );
}

export default OAuthPage;

